const ChangeRepartitionPopupBody = ({message, children}) =>  {

    return (
        <p>Change Repartition</p>
    );
  
};

export default ChangeRepartitionPopupBody;